import React, { useId } from 'react';
import { classNames } from '../../utils/style';
import { PopoverModal } from './PopoverModal';
import { PopupContent } from './PopupContent';
import { createPortal } from 'react-dom';
import { PopoverProps } from './types';
import { usePopover } from './hooks/usePopover';
import './styles.scss';

export * from './types';

export const Popover = ({
  position = 'top',
  activeHover = false,
  label,
  className,
  children,
  modalOnMediumScreen = false,
}: PopoverProps) => {
  const id = useId();

  const {
    triggerRef,
    contentRef,
    contentWrapperRef,
    isOpen,
    isMobile,
    isDesktopTooltip,
    currentPosition,
    handleOpen,
    handleButtonClick,
    closePopup,
  } = usePopover({ position, activeHover, modalOnMediumScreen });

  // Create popover content element
  const popoverContent = (
    <PopupContent
      id={id}
      closePopup={closePopup}
      ref={contentRef}
      position={currentPosition}
      isHoverable={isDesktopTooltip}
      modalOnMediumScreen={modalOnMediumScreen}
    >
      {children}
    </PopupContent>
  );

  // Main render
  return (
    <>
      {
        <>
          <button
            ref={triggerRef}
            onClick={handleButtonClick}
            disabled={isOpen && !activeHover && !isMobile}
            aria-haspopup="true"
            aria-expanded={isOpen}
            aria-controls={`popup_content_${id}`}
            aria-describedby={isDesktopTooltip ? id : undefined}
            className={classNames(
              'popover-trigger text-start',
              isDesktopTooltip && 'cursor-help',
              isMobile && activeHover && 'mobile-tooltip',
              'Popover',
              'group',
              className,
              isDesktopTooltip && 'cursor-help',
            )}
            onFocus={() => {
              if (isDesktopTooltip) {
                handleOpen(true);
              }
            }}
            onBlur={() => {
              if (isDesktopTooltip) {
                handleOpen(false);
              }
            }}
            onMouseEnter={() => {
              if (isDesktopTooltip) {
                handleOpen(true);
              }
            }}
            onMouseLeave={() => {
              if (isDesktopTooltip) {
                handleOpen(false);
              }
            }}
          >
            {label}
          </button>

          {/* Render popover content appropriately */}
          {isMobile && isOpen && <PopoverModal popover={popoverContent} />}
          {!isMobile &&
            typeof window !== 'undefined' &&
            createPortal(
              <div
                ref={contentWrapperRef}
                className={classNames(
                  !isOpen
                    ? 'popover-wrapper h-0 overflow-hidden opacity-0'
                    : 'popover-wrapper',
                )}
                style={{
                  position: 'absolute',
                  zIndex: 99,
                  transition:
                    'opacity 0.2s ease, top 0.1s ease, left 0.1s ease',
                }}
              >
                {popoverContent}
              </div>,
              document.body,
            )}
        </>
      }
    </>
  );
};
